import ExpandingTextBlock from './ExpandingTextBlock';

class ProductDatasheets {
  /**
   * @link ./ProductTabs
   */
   constructor() {
    this.container = document.querySelector('.product__tabcontent');
    this.pagecontent = document.querySelector('.product');
    
    this.loadContent();
    this.events();
  }

  events() {
    
  }
  /**
   * Retrieve html content for Datasheets tab
   * from Product API
   */
  loadContent() {
    const url = 'productapi/datasheets/';

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type':'text/html',
        'x-requested-with': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(data => {
      this.container.innerHTML = data;
      const exptext = new ExpandingTextBlock();
      this.pagecontent.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      })
    })
  }
}

export default ProductDatasheets;